import { HOSPITAL_PATIENT, HOSPITAL_PATIENT_SUBMISSION } from '../../../routes/urls';

export interface VisitWithoutImagesLinkInput {
    patientInvestigationUuid: string;
    visitUuid: string;
    firstSubmissionId?: number | null;
}

/** SKIN-55 — deep link from Analytics "visits without images" to the specific visit. */
export function buildVisitWithoutImagesLink(row: VisitWithoutImagesLinkInput): string {
    if (row.firstSubmissionId != null) {
        return HOSPITAL_PATIENT_SUBMISSION
            .replace(':uuidPatient', row.patientInvestigationUuid)
            .replace(':action', 'show')
            .replace(':idSubmission', String(row.firstSubmissionId))
            .replace(':typeTest', 'medical');
    }
    const patientUrl = HOSPITAL_PATIENT.replace(':uuidPatient', row.patientInvestigationUuid);
    return `${patientUrl}?visitUuid=${encodeURIComponent(row.visitUuid)}`;
}
